
/* eslint-disable */
import Vue from "vue";
import Component from "vue-class-component";
import { apiHandler } from "@/services/api-handler";
import { Api } from "shared/api";
import moment from "moment";
import { Watch } from "vue-property-decorator";
import * as XLSX from "xlsx";

@Component
export default class Orders extends Vue {
    weeklySalesData = [];
    locations = [];
    selectedYear = new Date().getFullYear();
    selectedWeekNumber = null;
    selectedMonth = null;
    displayedDate = "";
    isLoading = false;

    get weeksWithDates() {
        return Array.from({ length: 52 }, (_, i) => {
            const weekNumber = i + 1;
            const startDate = moment()
                .year(this.selectedYear)
                .week(weekNumber)
                .startOf("isoWeek")
                .format("MM/DD");
            const endDate = moment()
                .year(this.selectedYear)
                .week(weekNumber)
                .endOf("isoWeek")
                .format("MM/DD");
            return { number: weekNumber, startDate, endDate };
        });
    }

    async fetchLocations() {
        try {
            const locationsResponse = await apiHandler(() => Api.locations.Get());
            this.locations = locationsResponse.map((location) => ({
                ...location,
                monthly: !!location.monthly,
            }));
        } catch (error) {
            console.error("Error fetching locations:", error);
            this.locations = [];
        }
    }

    get formattedTitle() {
        if (this.selectedMonth && this.selectedMonth !== "null") {
            const [year, monthNum] = this.selectedMonth.split("-");
            const monthName = moment(`${year}-${monthNum}`, "YYYY-MM").format("MMMM");
            return ` - ${monthName} ${year}`;
        }
        return "";
    }

    get totals() {
    const totalData = {
        totalSales: 0,
        advertisingFee: 0,
        royaltyFee: 0,
        techFee: 0,
    };

    this.weeklySalesData.forEach((entry) => {
        const sales = Math.ceil(parseFloat(entry.total_sales) * 100) / 100;
        const advertising = Math.ceil(parseFloat(entry.advertising_fee) * 100) / 100;
        const royalty = Math.ceil(parseFloat(entry.royalty_fee) * 100) / 100;
        let tech = parseFloat(entry.tech_fee);

        // Apply the 4.3333 multiplier if a month is selected
        if (this.selectedMonth !== 'null' && this.selectedWeekNumber === null) {
            tech *= 4.3333;
        }

        // Round the tech fee to the nearest cent before summing
        tech = Math.ceil(tech * 100) / 100;

        // Add to totals
        totalData.totalSales += sales;
        totalData.advertisingFee += advertising;
        totalData.royaltyFee += royalty;
        totalData.techFee += tech;
    });

    // Calculate the total Royalty + Tech Fee after rounding each component
    const totalRoyaltyTechFee = Math.round((totalData.royaltyFee + totalData.techFee) * 100) / 100;

    return {
        totalSales: this.formatAndRoundAmount(totalData.totalSales),
        advertisingFee: this.formatAndRoundAmount(totalData.advertisingFee),
        royaltyFee: this.formatAndRoundAmount(totalData.royaltyFee),
        techFee: this.formatAndRoundAmount(totalData.techFee),
        totalRoyaltyTechFee: this.formatAndRoundAmount(totalRoyaltyTechFee),
    };
}






    async sendEmail(locationId) {
        try {
            const location = this.locations.find((loc) => loc.id === locationId);
            if (!location) {
                alert("Location data not found!");
                return;
            }

            let periodValue = "";
            if (location.monthly) {
                periodValue = `${this.selectedMonth.padStart(2, "0")}-01`;
            } else {
                periodValue = `${this.selectedYear}-${String(
                    this.selectedWeekNumber
                ).padStart(2, "0")}`;
            }

            const payload = {
                locationId: locationId,
                period: location.monthly ? "month" : "week",
                periodValue: periodValue,
            };

            const response = await apiHandler(() =>
                Api.email.sendReport.Post(payload)
            );
            alert("Email sent successfully!");
        } catch (error) {
            console.error("Error sending email:", error);
            alert("Failed to send email.");
        }
    }

    async getSignature(locationId, weekNumber) {
        try {
            const weekId = await this.calculateWeekId(this.selectedYear, weekNumber);

            if (weekId) {
                const response = await apiHandler(() =>
                    Api.weeklySalesData.signature[locationId][weekId].Get()
                );
                return response.signature || "";
            } else {
                console.error("Failed to calculate week ID");
                return "Failed to fetch signature";
            }
        } catch (error) {
            console.error("Error fetching signature:", error);
            return "Failed to fetch signature";
        }
    }

    async calculateWeekId(year: number, weekNumber: number): Promise<string | null> {
        try {
            const weekData = await apiHandler(() =>
                Api.weeks[year][weekNumber].Get());
            return weekData.id;
        } catch (error) {
            console.error("Error calculating week ID:", error);
            return null;
        }
    }

    get months() {
        const currentYear = this.selectedYear;
        const months = [];
        for (let i = 1; i <= 12; i++) {
            const month = `${currentYear}-${String(i).padStart(2, "0")}`;
            months.push(month);
        }
        return months;
    }

    formatMonth(month) {
        const [year, monthNum] = month.split("-");
        const monthName = moment(`${year}-${monthNum}`, "YYYY-MM").format("MMMM");
        return `${monthName} ${year}`;
    }

    @Watch("selectedMonth")
    onSelectedMonthChanged(newVal: string) {
        if (newVal !== "null") {
            this.selectedWeekNumber = null;
        }
    }

    @Watch("selectedWeekNumber")
    onSelectedWeekNumberChanged(newVal: number) {
        if (newVal !== null) {
            this.selectedMonth = "null";
        }
    }

    async fetchWeeklySalesData() {
        if (this.isLoading) {
            return;
        }
        this.isLoading = true;
        try {
            await this.fetchLocations();
            if (this.selectedMonth && this.selectedMonth !== "null") {
    const monthlySalesDataResponse = await apiHandler(() =>
        Api.monthlySales[this.selectedMonth].Get()
    );


    // Fetch week IDs
    const weekIds = await Promise.all(
        this.getWeeksInMonth(this.selectedMonth).map(weekNumber =>
            this.calculateWeekId(this.selectedYear, weekNumber)
        )
    );

    // Check for any null week IDs and log error if found
    if (weekIds.some(id => id === null)) {
        console.error("Found null week IDs:", weekIds);
    }

    this.weeklySalesData = await this.mergeLocationDataWithMonthlySignatures(
        monthlySalesDataResponse,
        weekIds
    );

    this.displayedDate = this.formatMonth(this.selectedMonth);
}

            else if (this.selectedWeekNumber && this.selectedYear) {
                const yearWeek = `${this.selectedYear}${String(
                    this.selectedWeekNumber
                ).padStart(2, "0")}`;
                const weeklySalesDataResponse = await apiHandler(() =>
                    Api.weeklySalesSummary[yearWeek].Get()
                );

                this.weeklySalesData = await this.mergeLocationDataWithSignatures(
                    weeklySalesDataResponse
                );

                const weekData = this.weeksWithDates[this.selectedWeekNumber - 1];
                if (weekData) {
                    this.displayedDate = `Week ${this.selectedWeekNumber} (${weekData.startDate} - ${weekData.endDate})`;
                } else {
                    console.error("Invalid week number or week data missing");
                    this.displayedDate = "";
                }
            } else {
                console.error("No valid period selected");
                this.weeklySalesData = [];
                this.displayedDate = "";
            }
        } catch (error) {
            console.error("Error fetching sales data:", error);
            this.weeklySalesData = [];
            this.displayedDate = "";
        } finally {
            this.isLoading = false;
        }
    }

    mergeLocationData(salesData) {
        return salesData.map((data) => {
            const location = this.locations.find((loc) => loc.id === data.location_id);
            return {
                ...data,
                monthly: location ? location.monthly : false,
            };
        });
    }
    
    async mergeLocationDataWithSignatures(salesData) {
    const mergedData = await Promise.all(
        salesData.map(async (data) => {
            const location = this.locations.find((loc) => loc.id === data.location_id);
            const signature = await this.getSignature(data.location_id, this.selectedWeekNumber);
            return {
                ...data,
                location_name: location ? location.name : 'Unknown Location',  // Add location_name
                monthly: location ? location.monthly : false,
                signature: signature,
            };
        })
    );

    return mergedData;
}

async mergeLocationDataWithMonthlySignatures(salesData) {
    return salesData.map((data) => {
        const location = this.locations.find((loc) => loc.id === data.location_id);
        return {
            ...data,
            location_name: location ? location.name : 'Unknown Location',  // Add location_name
            monthly: location ? location.monthly : false,
        };
    });
}


//     async mergeLocationDataWithMonthlySignatures(salesData, weekIds) {

//     const mergedData = await Promise.all(
//         salesData.map(async (data, index) => {
//             const location = this.locations.find((loc) => loc.id === data.location_id);
//             const allWeeksSigned = await this.checkAllWeeksSigned(data.location_id, weekIds);
//             return {
//                 ...data,
//                 monthly: location ? location.monthly : false,
//                 allWeeksSigned: allWeeksSigned,
//             };
//         })
//     );

//     return mergedData;
// }


async checkAllWeeksSigned(locationId, weekIds) {

    const signatures = await Promise.all(
        weekIds.map(async (weekId) => {
            const response = await apiHandler(() =>
                Api.weeklySalesData.signature[locationId][weekId].Get()
            );
            return response.signature || null;  // Explicitly return null if no signature
        })
    );

    // Only return true if every signature exists (not null or undefined)
    return signatures.every(signed => signed !== null && signed !== undefined);
}




    getWeeksInMonth(month) {
        const [year, monthNum] = month.split("-");
        const startDate = moment(`${year}-${monthNum}-01`);
        const endDate = startDate.clone().endOf("month");
        const weeks = [];

        for (let date = startDate; date.isBefore(endDate); date.add(1, "week")) {
            weeks.push(date.week());
        }

        return weeks;
    }

    formatAmount(amount) {
    return this.formatAndRoundAmount(amount);
}
formatAndRoundAmount(amount, multiplyTechFee = false) {
    if (isNaN(amount) || amount === null || amount === undefined) {
        console.log('Invalid amount:', amount);
        return "$0.00";
    }
    let num = parseFloat(amount);

    if (multiplyTechFee) {
        num *= 4.3333;
    }

    // Fix floating-point precision issues by rounding to two decimal places
    num = Math.round((num + Number.EPSILON) * 100) / 100;
    return `$${num.toFixed(2)}`;
}



calculateTotalFees(royalty, tech, multiplyTechFee) {
    let royaltyFee = parseFloat(royalty);
    let techFee = parseFloat(tech);

    // Multiply the tech fee by 4.3333 if the flag is true
    if (multiplyTechFee) {
        techFee *= 4.3333;
    }

    // Fix floating-point precision issues by rounding each component
    royaltyFee = Math.round((royaltyFee + Number.EPSILON) * 100) / 100;
    techFee = Math.round((techFee + Number.EPSILON) * 100) / 100;

    // Calculate the total after rounding each component
    const totalFees = Math.round((royaltyFee + techFee + Number.EPSILON) * 100) / 100;

    return `$${totalFees.toFixed(2)}`;
}





    async mounted() {
        await this.fetchLocations();
    }

    exportToExcel() {
    const dataForExport = this.weeklySalesData.map((data) => {
        // Calculate the total fees for each row
        const totalFees = this.calculateTotalFees(
            data.royalty_fee,
            data.tech_fee,
            this.selectedMonth !== 'null' && this.selectedWeekNumber === null
        );

        // Prepare each row's data
        return {
            "Location Name": data.location_name,
            "Total Sales": this.formatAndRoundAmount(data.total_sales),
            "Advertising Fee": this.formatAndRoundAmount(data.advertising_fee),
            "Royalty Fee": this.formatAndRoundAmount(data.royalty_fee),
            "Tech Fee": this.formatAndRoundAmount(
                Math.ceil(parseFloat(data.tech_fee) * (this.selectedMonth !== 'null' && this.selectedWeekNumber === null ? 4.3333 : 1) * 100) / 100
            ),
            "Royalty + Tech Fee": totalFees, // Include the total fees in the export
        };
    });

    // Add a row for the totals at the end of the sheet
    const totalsRow = {
        "Location Name": "TOTALS",
        "Total Sales": this.totals.totalSales,
        "Advertising Fee": this.totals.advertisingFee,
        "Royalty Fee": this.totals.royaltyFee,
        "Tech Fee": this.totals.techFee,
        "Royalty + Tech Fee": this.totals.totalRoyaltyTechFee,
    };

    // Append the totals row to the data
    dataForExport.push(totalsRow);

    // Generate the Excel worksheet and workbook
    const ws = XLSX.utils.json_to_sheet(dataForExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SalesData");

    // Save the Excel file
    XLSX.writeFile(wb, `SalesData_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
}


}
